import axios from 'axios';

export default {

    getSettingsDashboard (itemSectionId) {
        return axios.get('/api/settings/get/dashboard/settings', {params :{itemSectionId :itemSectionId}})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getHeaderSettings (itemSectionId) {
        return axios.get('/api/settings/get/header', {params :{itemSectionId :itemSectionId}})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getSettingsBanner (itemSectionId) {
        return axios.get('/api/settings/get/dashboard/banner/settings',{params :{itemSectionId :itemSectionId}})
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },
    getGiftCardAmount () {
        return axios.get('/api/settings/get/all-amount')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },

    getCurrentRegion () {
        return axios.get('/api/settings/get/current-region')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {console.log(error);})
    },
}